import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lms-approval-ui-adnoc-logo',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './adnoc-logo.component.html',
  styleUrl: './adnoc-logo.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdnocLogoComponent {
  @Input() variant: 'small' | 'splash' = 'small';
  @Input() vertical = false;
}
